(() => {
	document.addEventListener('pageLoad', () => {
		const acc = Array.from(document.querySelectorAll('.accordion'));
		if( acc.length === 0 ) {
			return;
		}
		
		const className = 'is-expanded';
		
		const _setup = (a, h, c) => {
			
			h.addEventListener('click', event => {
				event.preventDefault();
				if( a.classList.contains(className) ) {
					a.classList.remove(className);
					a.setAttribute('aria-expanded', false);
					return;
				}
				
				a.dataset.height = c.clientHeight;
				a.classList.add(className);
				a.setAttribute('aria-expanded', true);
			})
		};
		
		acc.forEach(a => {
			const h = a.querySelector('.accordion-header');
			const c = a.querySelector('.accordion-body')
			h && c && _setup(a, h, c);
		});
	});
})();